import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AES, enc } from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class AesEncryptionHelperService {

  AESEncryptionSecretKey = environment.aesEncryptionKey;

  constructor() { }

  encryptText(plaintext: string): string {
    if (plaintext) {
      return AES.encrypt(plaintext, this.AESEncryptionSecretKey).toString();
    }
  }

  decryptText(text: string): string {
    if (text) {
      const decryptedBytes = AES.decrypt(text, this.AESEncryptionSecretKey);
      const decrypted = decryptedBytes.toString(enc.Utf8);
      return decrypted;
    }
  }
}
